<div class="whole-container">
    <div class="wrapper generic-container">
        <div class="top-section">
            <span class="header">{{ "profile.label.account" | translate }}</span>
        </div>
        <div class="separator"></div>
        <div class="bottom-section">
            <div class="left-section" *ngIf="!isMobileView || showListOnMobile">
                <div class="first-section">
                    <p class="section" routerLinkActive="active-link" routerLink="/account/overview">
                        {{ "profile.label.overview" | translate }}
                    </p>
                </div>

                <div class="second-section">
                    <p class="order">{{ "profile.label.order" | translate }}</p>
                    <p class="section" routerLinkActive="active-link" routerLink="/account/trackOrder">
                        {{ "profile.label.order&Status" | translate }}
                    </p>
                </div>

                <div class="third-section">
                    <p class="section" routerLinkActive="active-link" routerLink="/account/rewards">
                        {{ "profile.label.rewards" | translate }}
                    </p>
                    <p class="section" routerLinkActive="active-link" routerLink="/account/myStructures">
                        {{ "profile.label.myStructure" | translate }}
                    </p>
                </div>

                <div class="fourth-section">
                    <p class="account">{{ "profile.label.account" | translate }}</p>
                    <p class="section" routerLinkActive="active-link" routerLink="/account/profileDetails">
                        {{ "profile.label.profile" | translate }}
                    </p>
                    <p class="section" routerLinkActive="active-link" routerLink="/account/addressDetails">
                        {{ "profile.label.address" | translate }}
                    </p>
                    <p class="section" (click)="logOut()">{{ "profile.label.logout" | translate }}</p>
                </div>
            </div>

            <div class="right-section" *ngIf="!isMobileView || !showListOnMobile">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
